exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errorMessage[data-v-4e7c49b9]{color:#ff5722;font-size:16px\n}\n.form-wrapper[data-v-4e7c49b9]{width:100%;padding:25px 20%\n}\n.form-wrapper .form-wrapper-frame[data-v-4e7c49b9]{width:100%;padding:25px;margin-bottom:15px\n}\n.form-wrapper .form-wrapper-frame .md-subheading[data-v-4e7c49b9]{margin-top:35px\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-4e7c49b9]{padding:10px .5%;margin-left:0\n}\n}\n.title-icon[data-v-4e7c49b9]{margin-top:-5px\n}\n#submit-btn[data-v-4e7c49b9]{margin:25px 0;width:33%;padding:6px;font-size:1.1em\n}\n.alert-msg[data-v-4e7c49b9]{margin-left:5px\n}\n.center[data-v-4e7c49b9]{margin:0 auto;position:relative;width:100%\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4e7c49b9","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/serie/SerieForm.vue
// module id = 178
// module chunks = 0